import type { FC } from "react";
import React from "react";
import { Body, Box } from "@edreamsodigeo/prisma-design-system";

import type { LightBoxPopoverCircleNumberProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";
import { LightBoxPopoverCircleNumberStyle } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/config/constants";

export const LightboxPopoverCircleNumber: FC<
  LightBoxPopoverCircleNumberProps
> = ({ number }) => (
  <Box sx={LightBoxPopoverCircleNumberStyle}>
    <Body type={"small"} color={"neutral.0"} weight={"medium"}>
      {number}
    </Body>
  </Box>
);
